module.exports = "  <router-outlet>\n\n    \n  </router-outlet>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main